<template lang="pug">
.requisites__content.content
  p Общество с ограниченной ответственностью «ЛОТОС»
  p Юридический адрес: 123098, РОССИЯ, Г. МОСКВА, ВН.ТЕР.Г.  МУНИЦИПАЛЬНЫЙ ОКРУГ ЩУКИНО, ГАМАЛЕИ УЛ., Д. 19, К. 2, ПОМЕЩ. 1/1
  p ИНН: 9703090283
  p ОГРН: 1227700310530
  p КПП: 773401001
  p ОКПО: 54161490
  p Расчетный счет: 40702810628100031064
  p Банк: ПАО АКБ "АВАНГАРД" г. МОСКВА
  p БИК: 044525201
  p Кор.счет: 30101810000000000201
</template>

<script>
export default {
  name: 'TheRequisitesContent'
}
</script>
